import { render, staticRenderFns } from "./viewWbxmInfo.vue?vue&type=template&id=4cb05aea&"
import script from "./viewWbxmInfo.vue?vue&type=script&lang=js&"
export * from "./viewWbxmInfo.vue?vue&type=script&lang=js&"
import style0 from "./viewWbxmInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports